import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";

export default function Label({
  children,
  className,
  htmlFor
}) {
  const classnames = cx(className);

  return (
    <label className={classnames} htmlFor={htmlFor}>
      {children}
    </label>
  );
}

Label.propTypes = {
  children: PropTypes.node,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.array,
    PropTypes.object
  ]),
  htmlFor: PropTypes.string
};
